export function getConfigureWidget(hitsPerPage = 10) {
    return window.instantsearch.widgets.configure({ hitsPerPage });
}
